"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.white = exports.black = void 0;
var _styledComponents = require("styled-components");
var _index = require("../../components/AccordionDrawer/index.styled");
var _index2 = _interopRequireDefault(require("../../components/Visualizer/index.styled"));
const black = exports.black = (0, _styledComponents.css)`
  background: #000;
  border-color: #000;
  ${_index.AccordionDrawer},
  ${_index.DrawerHeading},
  ${_index2.default.BottomBar},
  ${_index.DrawerContent},
  ${_index.DrawerButton}{
    background: #000;
    color: #fff;
  }
  ${_index2.default.SvgContainer},
  ${_index.DrawerIcon} {
    svg {
      fill: #fff;
    }
  }
  ${_index2.default.TabList} {
    .react-tabs__tab--selected:after {
      background: #fff;
    }
  }
`;
const white = exports.white = (0, _styledComponents.css)`
  background: #fff;
  color: #000;
`;